import AccountPage from "../../../../../appl/view/components/account/AccountPage";

export default function AccountTest() {

  return <div className='bg-cn-color-black-804'>
    <AccountPage/>
  </div>
}